import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import Dashboard from './Dashboard';
import DashboardPersonal from './DashboardPersonal';

// Admin y soporte ven el panel de gestión; el resto, un panel con solo su información personal.
export default function DashboardInicio() {
  const { user } = useAuth();
  return user?.role === 'admin' || user?.role === 'soporte' ? <Dashboard /> : <DashboardPersonal />;
}
